/* eslint-disable react-refresh/only-export-components */
import { ApolloProvider } from '@apollo/client';
import type { ReactElement } from 'react';
import React from 'react';
import { DndProvider } from 'react-dnd';
import ReactDOM, { render } from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';

import { store } from 'store';

import { ErrorBoundary } from 'common/component/ErrorBoundary/ErrorBoundary';
import { LaunchDarklyProvider } from 'common/featureFlags/LaunchDarklyProvider';
import ApolloClient from 'common/graphql/client';
import { logWebAppDetails } from 'common/utils/web_app_details';
import { CISnackBar } from 'common/viewcomp/general/ci_pagestatus';
import { CITheme } from 'common/viewcomp/general/CITheme';
import { Html5AndTouchBackend } from 'common/viewcomp/layout/dnd-multi-backend';

import App from './app';

if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_TEST_ACCESSIBILITY === 'true') {
    import('@axe-core/react').then(({ default: axe }): void => {
        axe(React, ReactDOM, 1000);
    });
}

logWebAppDetails();

const WithProvider = (): ReactElement => (
    <CITheme>
        <ErrorBoundary>
            <ReduxProvider store={store}>
                <CISnackBar />
                <ApolloProvider client={ApolloClient}>
                    {/* TODO: REMOVE COMMENTED TAGS UNTIL MAJOR PACKAGES HAVE BEEN UPGRADED */}
                    {/* <React.StrictMode> */}
                    <DndProvider backend={Html5AndTouchBackend}>
                        <LaunchDarklyProvider>
                            <App />
                        </LaunchDarklyProvider>
                    </DndProvider>
                    {/* </React.StrictMode> */}
                </ApolloProvider>
            </ReduxProvider>
        </ErrorBoundary>
    </CITheme>
);

if (document.getElementById('root')) {
    render(<WithProvider />, document.getElementById('root'));
}
